import { render, staticRenderFns } from "./PatientInfoCard.vue?vue&type=template&id=95d0a6f2&scoped=true"
import script from "./PatientInfoCard.vue?vue&type=script&lang=js"
export * from "./PatientInfoCard.vue?vue&type=script&lang=js"
import style0 from "./PatientInfoCard.vue?vue&type=style&index=0&id=95d0a6f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d0a6f2",
  null
  
)

export default component.exports